import { useEffect, useState } from 'react';
import './App.css'
import { routes } from './folder/screens/components/routes/router';
import { Routes,Route, BrowserRouter } from 'react-router-dom';
import AOS from 'aos';
import "aos/dist/aos.css";
import { Toaster } from 'react-hot-toast';
import PrivateRoute from './folder/screens/components/routes/PrivateRoute';


function App() {

  const [loader,setloader] = useState(true)

  useEffect(()=>{
    AOS.init();
    setTimeout(() => {
      setloader(false)
    }, 2000);
  },[])

  return (
    <div className='w-screen overflow-x-hidden'>
      <Toaster  position="bottom-center" toastOptions={{
            success: {
              style:{
                background:'black',
                color:'white',
                padding:'4px 7px',
                fontSize:'12px',
                borderRadius:'2px',
                iconTheme: {
                  fontSize:'4px'
                }
              }
            },
            error: {
              style:{
                background:'black',
                color:'white',
                padding:'4px 7px',
                fontSize:'12px',
                borderRadius:'2px',
                iconTheme: {
                  fontSize:'4px'
                }
              }
            }
          }}  />
    {loader ?
    // <Splash />
    <></>
    :
    <BrowserRouter>
    <Routes>
      {routes.map((screen, index) => (
        <Route
          key={index}
          path={screen.path}
          element={
            screen.private ? (
              <PrivateRoute>{screen.component}</PrivateRoute>
            ) : (
              screen.component
            )
          }
        />
      ))}
    </Routes>
  </BrowserRouter>
    }  
    </div>
  );
}

export default App;
